import React from "react";

const YouTubeVideo = () => {
  return (
    <div
      style={{
        height: "100%", width: "100%"
      }}
    >
      <iframe
        src="https://s3.us-east-1.amazonaws.com/www.nocapvote.com/uploads/admanager/homepagevideo.mp4"
        frameBorder="0"
        allow="autoplay"
        allowFullScreen
        style={{
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
        }}
        title="youtube_video"
      />
    </div>
  );
};

export default YouTubeVideo;
